module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-3-3-b7bff8f44642410fb792f41d64d1887a.jpg";